import React from "react";

/**
 * Answer-first "Key Facts" block for GEO/AEO.
 * Renders factual, extraction-friendly bullets near the top of an article
 * so generative engines (ChatGPT, Perplexity, Google AI Overviews) can cite it.
 */
export default function CiteSummary({ heading = "Key Facts", items = [] }) {
  return (
    <section
      aria-label="Article summary"
      className="cite-summary mb-10 p-6 bg-accent/60 border-l-4 border-secondary rounded-r-xl"
    >
      <h2 className="text-sm font-bold uppercase tracking-wide text-accent-foreground mb-3">
        {heading}
      </h2>
      <ul className="space-y-2 list-disc pl-5">
        {items.map((item, i) => (
          <li key={i} className="text-sm text-foreground leading-relaxed">
            {item}
          </li>
        ))}
      </ul>
    </section>
  );
}